import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useStateContext } from "../../Contexts/ContextProvider";
import AxiosClient from "../../assets/AxiosClient";


export default function AccountSetting () {
    const {user   ,setToken , SetNotification } = useStateContext  () ; 
    const navigate = useNavigate();
  const [loading , setIsLoading] = useState(false) ; 
const oldpassRef = useRef () ; 
const newpassRef = useRef () ; 
const renewpassRef = useRef () ; 
const id = user.id ; 
const change_password = async(e) =>{ 
        e.preventDefault() ; 
      setIsLoading(true) ; 
        const payload = {
              oldpass : oldpassRef.current.value,
              newpass : newpassRef.current.value  ,
              id : id 
            }
       
        if (newpassRef.current.value != renewpassRef.current.value){
          SetNotification( "New Password does'nt Match !! " ,  "danger");
          setIsLoading(false) ; 

          return ; 
        }
        AxiosClient.post(`Users/updatePassword` ,payload )
       .then((response) =>{
        const {token} = response.data; 
        SetNotification( "Your Information has been updated successfuly " ,  "success");
        setToken(token) ;
        navigate("/Account");
       })
       .catch((error)=> 
       {
        setIsLoading(false) ; 

        SetNotification( "something bad happen !! " ,  "danger");}) ;
          
    }
  
    return (
       
                <div className="col-12 col-xl-4">
              <div className="card card-plain h-100">
                <div className="card-header pb-0 p-3">
                  <div className="row">
                    <div className="col-md-8 d-flex align-items-center">
                      <h6 className="mb-0">Profile Information</h6>
                    </div>
                    <div className="col-md-4 text-end">
                     
                    </div>
                  </div>
                </div>
                <form className="card-body p-3">
                  <p className="text-sm">
                  </p>
                  <hr className="horizontal gray-light my-4"/>
                  <ul className="list-group">
                    <li className="list-group-item border-0 ps-0 pt-0"><strong className="text-dark h5">Old password:</strong> 
                    <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Old Password" ref={oldpassRef}  required/>
          </div>
                    </li>
                    <li className="list-group-item border-0 ps-0 pt-0">
                      <strong className="text-dark h5">New password :</strong> 
                      <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="New Password" ref={newpassRef }  required 
          />
          </div>
                      
                       </li>
                    <li className="list-group-item border-0 ps-0 pt-0">
                      <strong className="text-dark h5"> Rewrite new password :</strong>
                      <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="rewrite New Password" ref={renewpassRef  } required 
          />
          </div>
                       
                        </li>

                    <li className="list-group-item border-0 ps-0 pb-0">
                    <Link  to= "/Account" className="btn btn-danger m-2">
                        Cancel
                      </Link>
                      {loading? <h6 className="btn">loading</h6> : (  <a  onClick={change_password} className="btn btn-info m-2">
                        Save
                      </a>)}
                     
                    </li>
                  </ul>
                </form>
              </div>
            </div>
      
    )
}